/**
 * Extracts `data-` attributes from the DayPicker props.
 *
 * This function collects all `data-` attributes from the props and adds
 * additional attributes based on the DayPicker configuration.
 *
 * @param props The DayPicker props.
 * @returns An object containing the `data-` attributes.
 */
export function getDataAttributes(props) {
  var _props$mode;
  const dataAttributes = {
    "data-mode": (_props$mode = props.mode) !== null && _props$mode !== void 0 ? _props$mode : undefined,
    "data-required": "required" in props ? props.required : undefined,
    "data-multiple-months": props.numberOfMonths && props.numberOfMonths > 1 || undefined,
    "data-week-numbers": props.showWeekNumber || undefined,
    "data-broadcast-calendar": props.broadcastCalendar || undefined,
    "data-nav-layout": props.navLayout || undefined
  };
  Object.entries(props).forEach(_ref => {
    let [key, val] = _ref;
    if (key.startsWith("data-")) {
      dataAttributes[key] = val;
    }
  });
  return dataAttributes;
}